// extracted by mini-css-extract-plugin
module.exports = {"reading":"Reading_reading__20x8Q","timer":"Reading_timer__2NKRZ","warning":"Reading_warning__KzIgY","info":"Reading_info__2dJfS"};